import "./ProfessionalDocumentSection.css";

function ProfessionalDocumentSection({
  title,
  description,
  badge,
  children,
}) {
  return (
    <section className="professional-document-section">
      <div className="professional-document-section-header">
        <div>
          <h2>{title}</h2>

          {description && (
            <p>{description}</p>
          )}
        </div>

        {badge && (
          <span className="professional-document-section-badge">
            {badge}
          </span>
        )}
      </div>

      <div className="professional-document-section-content">
        {children}
      </div>
    </section>
  );
}

export default ProfessionalDocumentSection;